import React from "react";
import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Provider from "../Provider";
import { useStyle } from "../styles";
// import { DropzoneArea } from "material-ui-dropzone";
import { ColorButton } from "../../../services/helper";

function FormTwo() {
  const classes = useStyle();
  const {
    handleCarType,
    carName,
    setCarname,
    carNo,
    setCarNo,
    carType,
    fillCarTypes,
    errorsFormOne,
    handleSubmitFormTwo,
  } = Provider();

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.box}>
          <div className={classes.heading}>Driver Car Information</div>

          <Grid container spacing={1} style={{ marginTop: 5 }}>
            {/* <DropzoneArea
              acceptedFiles={["image/*"]}
              filesLimit={10}
              dropzoneText={"Drag and drop an image here or click Here"}
              onChange={(files) => handleCarImages(files)}
              //   onDelete={(files) => clearValue(files)}
            /> */}
            <Grid item xs={6}>
              <TextField
                fullWidth
                onChange={(event) => setCarname(event.target.value)}
                label="Car Name"
                value={carName}
                variant="outlined"
                InputProps={{
                  style: { fontFamily: "Poppins, sans-serif" },
                }}
                InputLabelProps={{
                  style: { fontFamily: "Poppins, sans-serif" },
                }}
                required
                error={!!errorsFormOne.carName}
                helperText={errorsFormOne.carName}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                onChange={(event) => setCarNo(event.target.value)}
                label="Car Number"
                variant="outlined"
                value={carNo}
                inputProps={{ maxLength: 12 }}
                InputProps={{
                  style: { fontFamily: "Poppins, sans-serif" },
                }}
                InputLabelProps={{
                  style: { fontFamily: "Poppins, sans-serif" },
                }}
                required
                error={!!errorsFormOne.carNo}
                helperText={errorsFormOne.carNo}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ fontFamily: "Poppins" }}
                >
                  Car Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={carType}
                  label="Car Type"
                  onChange={handleCarType}
                  sx={{ fontFamily: "Poppins" }}
                  error={!!errorsFormOne.carType}
                  helperText={errorsFormOne.carType}
                >
                  <MenuItem value={"Choose Type..."}>Choose Type...</MenuItem>
                  {fillCarTypes()}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <ColorButton onClick={handleSubmitFormTwo} variant="contained">
                Next
              </ColorButton>
            </Grid>
            {/* <Grid item xs={6}>
          <Button onClick={handleReset} fullWidth variant="contained">
            Reset
          </Button>
        </Grid> */}
          </Grid>
        </div>
      </div>
    </>
  );
}

export default FormTwo;
